const burger = document.querySelector('.oframenu-mobile__burger');
const menu = document.querySelector('.oframenu-mobile__menu');
const itemIcons = document.querySelectorAll('.oframenu-mobile__item-icon');
const modals = document.querySelectorAll('.oframenu-mobile__modal');
const closeButtonModal = document.querySelector('.oframenu-mobile__burger--close');
const closeButtons = document.querySelectorAll('.oframenu-mobile__submodal-close');

if (closeButtonModal) {
    closeButtonModal.addEventListener('click', () => {
        menu.classList.remove('oframenu-mobile__menu--open');
        burger.classList.remove('oframenu-mobile__burger--active');
    });
}

burger.addEventListener('click', () => {
  menu.classList.toggle('oframenu-mobile__menu--open');
  burger.classList.toggle('oframenu-mobile__burger--active');
});


function openModal(modalId) {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.classList.add('oframenu-mobile__modal--open');
  }
}


itemIcons.forEach(icon => {
  icon.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const modalId = icon.getAttribute('data-open-modal');
    openModal(modalId);
  });
});


document.querySelectorAll('.oframenu-mobile__item, .oframenu-mobile__modal-item').forEach(item => {
  const icon = item.querySelector('.oframenu-mobile__item-icon');
  if (icon) {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      const modalId = icon.getAttribute('data-open-modal');
      openModal(modalId);
    });
  }
});

closeButtons.forEach(button => {
  button.addEventListener('click', () => {
    const modal = button.closest('.oframenu-mobile__modal');
    modal.classList.remove('oframenu-mobile__modal--open');
  });
});

const dropdownToggles = document.querySelectorAll('.oframenu-mobile__item--highlighted');
const plusPath = "M0,12a1.5,1.5,0,0,0,1.5,1.5h8.75a.25.25,0,0,1,.25.25V22.5a1.5,1.5,0,0,0,3,0V13.75a.25.25,0,0,1,.25-.25H22.5a1.5,1.5,0,0,0,0-3H13.75a.25.25,0,0,1-.25-.25V1.5a1.5,1.5,0,0,0-3,0v8.75a.25.25,0,0,1-.25.25H1.5A1.5,1.5,0,0,0,0,12Z";
const minusPath = "M0,12a1.5,1.5,0,0,0,1.5,1.5h21a1.5,1.5,0,0,0,0-3h-21A1.5,1.5,0,0,0,0,12Z";

dropdownToggles.forEach(toggle => {
  toggle.addEventListener('click', (e) => {
    e.preventDefault();
    const dropdownContent = toggle.nextElementSibling;
    const isOpen = dropdownContent.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen);
    const pathElement = toggle.querySelector('.icon-path');
    pathElement.setAttribute('d', isOpen ? minusPath : plusPath);
  });
});

const itemLinks = document.querySelectorAll('.oframenu-mobile__item[data-open-modal]');
const toggleButtons = document.querySelectorAll('.oframenu-mobile__toggle-button');
const forms = document.querySelectorAll('.oframenu-mobile__form');
const forgotButtonWrapper = document.querySelectorAll('.oframenu-mobile__forgot-button-wrapper');

itemLinks.forEach(link => {
  link.addEventListener('click', (e) => {
    e.preventDefault();
    const modalId = link.getAttribute('data-open-modal');
    const modal = document.getElementById(modalId);
    modal.classList.add('oframenu-mobile__modal--open');
  });
});

toggleButtons.forEach(button => {
    button.addEventListener('click', () => {
      const formType = button.getAttribute('data-form');
  
      toggleButtons.forEach(btn => btn.classList.remove('oframenu-mobile__toggle-button--active'));
      button.classList.add('oframenu-mobile__toggle-button--active');

      forms.forEach(form => form.classList.remove('oframenu-mobile__form--active'));
      const activeForm = document.querySelector(`.oframenu-mobile__form[data-form="${formType}"]`);
      activeForm.classList.add('oframenu-mobile__form--active');
  
      forgotButtonWrapper.forEach(wrapper => {
        wrapper.style.display = formType === 'login' ? 'flex' : 'none';
      });
    });
  });

/*
const forgotPasswordButton = document.querySelector('.oframenu-mobile__forgot-button');
const forgotPasswordModal = document.getElementById('modal-forgot-password');
const closeForgotPasswordModal = document.querySelector('#modal-forgot-password .oframenu-mobile__submodal-close');


forgotPasswordButton.addEventListener('click', (e) => {
    e.preventDefault();
    forgotPasswordModal.classList.add('oframenu-mobile__modal--open');
});

closeForgotPasswordModal.addEventListener('click', () => {
    forgotPasswordModal.classList.remove('oframenu-mobile__modal--open');
});
*/